import * as React from "react";
import { Component } from "react";
const radioSelect = require("../../assets/images/radio-selected.png");
const radioNonSelected = require("../../assets/images/radio-unselected.png");

interface Props {
    index: any;
    selected: any;
    label: any;
    onChange: any;
}

const Radio = ({ index, selected, label, onChange }: Props) => {
    return (
        <div
            onClick={() => onChange(index)}
            style={{
                display: "flex",
                alignItems: "center",
                gap: "0.25rem",
                marginBottom: "0.5rem",
            }}
        >
            <img src={selected ? radioSelect : radioNonSelected} />
            <label>{label}</label>
        </div>
    );
};

export default Radio;
